<div class="purchase-orders-page">
  <section *ngIf="showPurchaseOrderList" class="purchase-orders-list-view">
    <header class="list-header">
      <div><h1>Purchase orders</h1><p>Find an order or create a single PO or spread.</p></div>
      <div class="list-actions">
        <button type="button" mat-flat-button class="btn-bg-green" (click)="startNewPurchaseOrder()"><mat-icon>add</mat-icon>New PO</button>
        <button type="button" mat-flat-button class="btn-bg-green" (click)="startNewMultiPurchaseOrder()"><mat-icon>content_copy</mat-icon>New spread</button>
        <button class="btn-bg-purple" type="button" mat-button [disabled]="PrintPOPDF" (click)="generatePdf()"><mat-icon>picture_as_pdf</mat-icon>Worksheet</button>
      </div>
    </header>
    <div class="list-filters">
      <rms-select label="Search by" [options]="searchOptions" [(ngModel)]="searchOption"></rms-select>
      <rms-input label="Search {{searchOption}}" [(ngModel)]="searchText" [debounce]="150"></rms-input>
      <rms-select label="Order type" [(ngModel)]="orderType" [options]="[{value:'',label:'All orders'},{value:'single',label:'Single PO'},{value:'spread',label:'Spread'}]"></rms-select>
      <span class="result-count" aria-live="polite">{{filteredPurchaseOrders.length}} results</span>
    </div>
    @if(loading){<p role="status">Loading purchase orders…</p>}
    @if(loadError){<div role="alert" class="load-error">{{loadError}} <button class="btn-bg-blue" type="button" mat-button (click)="retryLoad()">Retry</button></div>}
    @if(!loading && !loadError && !filteredPurchaseOrders.length){<p class="empty-state">No purchase orders match your search.</p>}
    <section class="purchase-orders-table" [attr.aria-busy]="loading">
      <rms-table startSort="PurchaseOrderID" [data]="filteredPurchaseOrders" [columns]="POColumns" [clickableRow]="true" (onRowClick)="onSelectPurchaseOrder($event)"></rms-table>
    </section>
  </section>

  <div *ngIf="selectedPurchaseOrder" class="form-view grow-from-top-left">
    <app-purchase-order-form [OfferSample]="OfferSample"
                             [PurchaseOrder]="selectedPurchaseOrder"
                             (onReturnToSpread)="onSelectPurchaseOrder($event)"
                             (OnSavePO)="onSavePO($event)"
                             (OnRefreshPO)="refreshPurchaseOrderList()"
                             (ReturnToList)="ReturnToList()">
    </app-purchase-order-form>
  </div>

  @if (MultiPurchaseOrder || selectedPurchaseOrders) {
  <div class="form-view multi-po-view grow-from-top-left">
    <app-multi-purchase-order-form [selectedPurchaseOrders]="selectedPurchaseOrders || []"
                                   (onSavePOSpread)="onSavePOSpread($event)"
                                   (CancelForm)="onCancelMultiPurchaseOrderForm()">
    </app-multi-purchase-order-form>
  </div>
  }

  @if (SelectedPurchaseOrderSpread) {
  <div class="form-view grow-from-top-left">
    <app-spread-purchase-order-form [PurchaseOrderSpread]="SelectedPurchaseOrderSpread"
                                    (onViewPurchaseOrder)="ViewPurchaseOrderFromSpread($event)"
                                    (onViewSpread)="onReviewSpread($event)"
                                    (onUpdateSpread)="onUpdateSpread($event)"
                                    (ReturnToList)="CloseSpreadScreen($event)">
    </app-spread-purchase-order-form>
  </div>
  }
</div>

@if (PrintPOPDF) {
<div #pdfContainer class="print-container-landscape">
  <ng-container *ngIf="inventoryFormComponentType">
    <ng-container *ngComponentOutlet="inventoryFormComponentType; inputs: { Pdf: true }">
    </ng-container>
  </ng-container>
</div>
}
